<template>
  <div class="flag" v-if="mode != 'inside_lite'">
    <span :class="{
        'mode': true,
        [mode]: true
    }">{{ modeTitles[mode] }}</span>
    <span class="commission" v-if="showCommission">
      <slot></slot>
    </span>
  </div>
  <div class="flag" v-else>
    <span class="mode inside-lite">
        INSIDE <small class="inside-lite-tag">lite</small>
    </span>
    <span class="commission" v-if="showCommission">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: "inside"
    }
  },
  computed: {
    modeTitles() {
      return {
        inside: 'INSIDE',
        preorder: 'TAKEAWAY',
        delivery: 'DELIVERY',
        reserve: 'RESERVE',
        inside_lite: 'INSIDE lite',
        pro: 'PRO',
        hotels: 'ROOMS'
      }
    },
    showCommission() {
      return !!this.$slots.default;
    }
  }
};
</script>

<style scoped>
.flag {
  display: flex;

  position: relative;
}

.flag:first-child {
  margin: 0;
}

.flag .mode {
  color: #ededed;
  text-align: center;
  position: relative;
  z-index: 2;
  width: 15vh;
  font-weight: bold;
  display: inline-block;
  border-top-left-radius: 0.8vh;
  border-bottom-left-radius: 0.8vh;
  font-size: 1.7vh;
  background: #262626;
  padding: 0.4vh 0 0.4vh;
}

.flag-disabled {
  color: #a4a3a1;
}

span.commission {
  background: #464646;
  padding: 0.4vh 2vh 0.4vh 3vh;
  display: block;
  text-align: center;
  z-index: 0;
  min-width: 10vh;
  margin-left: -1vh;
  border-radius: 0 0.8vh 0.8vh 0;
  font-size: 1.7vh;
  color: #ededed;
}

.commission.fix-price {
  padding: 0.4vh 0 0.4vh 1.8vh;
}

.inside {
  background: #1d1d1b !important;
  color: #ededed !important;
}
.preorder {
  background: #ffd2a8 !important;
  color: #1d1d1b !important;
}
.delivery {
  background: #cbd9e6 !important;
  color: #1d1d1b !important;
}
.reserve {
  background: #aeccc6 !important;
  color: #1d1d1b !important;
}
.pro {
  background: #129b81 !important;
  color: #ededed !important;
}
.inside-lite {
  background: #1d1d1b !important;
  color: #ededed !important;
}
.hotels {
  background: #ededed !important;
  color: #1d1d1b !important;
}

.inside-lite-tag {
  color: #AECCC6;
  /* position: absolute; */
  /* top: 1.2vh; */
  /* right: 0.9vh; */
}
</style>